import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M42 42v8m12-35v10M34 15v10M13 15v10m1 10v7h40s0-6.906-.03-6.906\" stroke=\"#fff\" stroke-width=\"2\" fill=\"none\"></path><path d=\"M43 4h18v14H43V4zm0 18h18v14H43V22zM4 45h57v14H4V45zM3 22h38v14H3V22zM23 4h18v14H23V4zM3 4h18v14H3V4z\" fill=\"#55acba\"></path><path d=\"M40.063 40.25v8m12-32.643v9.643m-20-10v9.643m-16.5 11.2v3.657h36v-4.78m-40.5-19.72v9.643\" stroke=\"#1e3951\" stroke-width=\"2\" fill=\"none\"></path><path d=\"M46 6.5h12v8H46v-8zm0 18h12v8H46v-8zm-20-18h12v8H26v-8zm-20 0h12v8H6v-8z\" stroke=\"#fff\" stroke-width=\"2\" fill=\"#86bc4d\"></path><path d=\"M7 48h51v8H7v-8zM6 25h32v8H6v-8z\" stroke=\"#fff\" stroke-width=\"2\" fill=\"#55acba\"></path>", 5)
  ])))
}
export default { render: render }